<template>
  <v-container fluid>
    <v-row class="justify-center">
      <v-col cols="12">
        <v-row class="justify-center">
          <v-col cols="12" class="text-center mb-4">
            <v-img
              class="mx-auto"
              width="200"
              alt="overview reinstatement icon"
              src="../assets/OverviewImage.svg"
            />
          </v-col>
          <v-col cols="12" sm="8" md="10" class="text-left font-size--16">
            {{
              $t(
                'L_this_process_will_guide_you_through_the_steps_to_reinstate_your_primerica_life_insurance'
              )
            }}
          </v-col>
          <v-col cols="12" sm="8" md="10" class="text-left font-size--16 mt-4">
            {{ $t('L_the_following_information_will_be_needed_complete_the_application') }}
          </v-col>
          <v-col
            cols="12"
            sm="8"
            md="10"
            class="blueText mb-4 mt-4 text-left font-size--16 font-weight-bold"
          >
            <ul class="pl-4">
              <li>{{ $t('L_medical_information_for_all') }}</li>
              <li>{{ $t('L_doctors_contact_information') }}</li>
              <li>{{ $t('L_the_bank_routing_and_account_number') }}</li>
            </ul>
          </v-col>
          <v-col cols="12" sm="8" md="10" class="text-left font-size--16 font-weight-regular">
            <p>
              <span>{{
                $t(
                  'L_if_you_have_questions_or_prefer_to_receive_a_paper_reinstatement_application',
                  [customerServicePhoneNum]
                )
              }}</span>
            </p>
          </v-col>
        </v-row>

        <!-- Button -->
        <v-row class="d-flex align-center justify-center py-4">
          <v-col cols="12" sm="6" md="4" class="pr-4">
            <OnexButton
              :disabled="disableActions"
              block
              variant="outlined"
              color="primary"
              @click="cancelAction"
            >
              {{ $t('L_cancel') }}
            </OnexButton>
          </v-col>
          <v-col cols="12" sm="6" md="4" class="pr-4">
            <OnexButton
              :disabled="disableActions"
              target="_blank"
              block
              color="primary"
              @click="continueAction"
            >
              {{ $t('L_continue') }}
            </OnexButton>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global/global.store';
import { defineComponent, type ComponentOptions } from 'vue';
import { OnexButton } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'ReinstatementProcessOverview',
  components: {
    OnexButton,
  },
  props: {
    disableActions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(useGlobalStore, {
      locale: 'getLocale',
    }),
    customerServicePhoneNum() {
      if (this.locale === 'en_US') {
        return '(800) 257-4725';
      } else if (this.locale === 'en_CA') {
        return '(800) 387-7876';
      } else if (this.locale === 'fr_CA') {
        return '(800) 265-4804';
      }
      return '(800) 257-4725';
    },
  },
  methods: {
    continueAction() {
      this.$emit('continueClicked');
    },
    cancelAction() {
      this.$emit('cancelClicked');
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.blueText {
  color: #063562;
}
</style>
